<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>高级功能</el-breadcrumb-item>
        <el-breadcrumb-item>云函数</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    
    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button size="small" type="primary" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addRemoteFnBtn" :loading="state">添加云函数</el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="addRemoteFnForm" class="demo-form-inline" ref="RemoteFnRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName">
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeVal" :style="colorState ? 'color:red;' : 'color:;'">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item" :style="item == '全软件通用' ? 'color:red;': 'color:;'"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>
      <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">*为防止滥用云函数，每个用户每月有10万次免费额度，超过的按 10万次/1元/月 计费，不足10万次的按10万次计算。</el-tag>
      <el-table :data="tableList" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="softName" label="所属软件" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.softName == '全软件通用'" style="color: red" >全软件通用</span>
            <span v-else>{{scope.row.softName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fnName" label="函数名" width="170"></el-table-column>
        <el-table-column prop="fnCode" label="函数代码" width="370"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <!-- <el-table-column prop="createDate" label="创建时间" width="170"></el-table-column>
        <el-table-column prop="createDate" label="修改时间" width="170"></el-table-column> -->
        <el-table-column prop="createdAt" label="创建时间" width="170"></el-table-column>
        <el-table-column prop="updatedAt" label="修改时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editRemoteFnBtn(scope.row)">编 辑</el-button>
            <el-button @click="delRemoteFnBtn(scope.row)" size="mini" type="danger">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新建云函数 -->
    <el-dialog title="新建云函数" :close-on-click-modal="false" :visible.sync="addDialogVisible" :width="addRemoteFnWidth" @close="closeAddDiaLog">
      <el-form :model="addRemoteFnForm" :rules="addRemoteFnrules" ref="addRemoteFnFormRef" label-width="160px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="addRemoteFnForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="函数名" prop="fnName" >
          <el-input v-model="addRemoteFnForm.fnName" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="函数代码(JavaScript)" prop="fnCode">
            <el-input v-model="addRemoteFnForm.fnCode" v-show="false"></el-input>
            <MonacoEditor
              v-model="addRemoteFnForm.fnCode"
              height="400"
              width="480"
              language="javascript"
              :code="addRemoteFnForm.fnCode"
              :key="randomkey"
              :editorOptions="options"
              @mounted="onMounted1"
              @codeChange="onAddCodeChange"
              >
            </MonacoEditor>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="addRemoteFnForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="createRemoteFn" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 编辑云函数Dialog -->
    <el-dialog title="编辑云函数" :close-on-click-modal="false" :visible.sync="editRemoteFnDialogVisible" :width="addSubWidth" @close="closeEditDiaLog">
      <el-form :model="editRemoteFnForm" :rules="editRemoteFnrules" ref="editRemoteFnRef" label-width="160px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="editRemoteFnForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="函数名" prop="fnName" >
          <el-input v-model="editRemoteFnForm.fnName" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="函数代码(JavaScript)" prop="fnCode">
          <el-input type="textarea" v-model="editRemoteFnForm.fnCode" v-show="false"></el-input>
          <MonacoEditor
            v-model="editRemoteFnForm.fnCode"
            height="400"
            width="480"
            language="javascript"
            :code="editRemoteFnForm.fnCode"
            :key="randomkey"
            :editorOptions="options"
            @mounted="onMounted2"
            @codeChange="onEditCodeChange"
            >
          </MonacoEditor>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="editRemoteFnForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="editSaveBtn">保 存</el-button>
      </span>
    </el-dialog>



    <!-- 删除此云函数dialog -->
    <el-dialog title="确定要删除此云函数" :close-on-click-modal="false" :visible.sync="delRemoteFnDialog" :width="RemoteFnRightWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此云函数</span>
      </div>

      <span style="margin-left:30px">{{editRemoteFnForm.fnName}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delRemoteFnDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delRemoteFnDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco-editor'
export default {
  components: {
    MonacoEditor
  },
  data(){
    return{
      editor1:null,
      editor2:null,
      randomkey:1231231,
      options: {
        selectOnLineNumbers: false
      },

      addDialogVisible: false,
      addRemoteFnForm:{
        fnCode: ""
      },
      editRemoteFnForm:{
        fnCode: ""
      },
      addRemoteFnrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        fnName: [
          { required: true, message: "请填写函数名!", trigger: ["blur", "change"] },
          { max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        fnCode: [
          { required: true, message: "请填写函数代码", trigger: ["blur", "change"] },
          { max: 2048,message: "不能超过2048个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      editRemoteFnrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        fnName: [
          { required: true, message: "请填写函数名!", trigger: ["blur", "change"] },
          { max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        fnCode: [
          { required: true, message: "请填写函数代码!", trigger: ["blur", "change"] },
          { max: 2048,message: "不能超过2048个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      state:false,
      allSoftName:"",

      tableList:[],
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      editRemoteFnDialogVisible:false,

      integralForm:{
        action:"购买",
        integral:0
      },
      integralFormrules:{
        action:[
          { required: true, message: "请选择!", trigger: ["blur", "change"] }
        ],
        
      },
      integralInfo:"",
      rightDialogVisible:false,
      upperLimit:false,
      delRemoteFnDialog:false,
      loading:true,
      addRemoteFnWidth:'700px',
      addSubWidth:'700px',
      RemoteFnRightWidth:'500px',
      colorState: false,
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getRemoteFnList()
    if (document.body.clientWidth < 700){
      this.addRemoteFnWidth = '100%'
      this.addSubWidth = '100%'
      this.RemoteFnRightWidth = '100%'
    }
  },
  methods:{
    onMounted1(editor) {
      this.editor1 = editor;
      console.log("editor1",this.editor1);
      // this.editor.setValue("")
    },
    onMounted2(editor) {
      this.editor2 = editor;
      console.log("editor2",this.editor2);
      // this.editor.setValue("")
    },
    // 新建代码改变
    onAddCodeChange(editor) {
      this.addRemoteFnForm.fnCode = editor.getValue()
    },
    // 编辑代码改变
    onEditCodeChange(editor) {
      this.editRemoteFnForm.fnCode = editor.getValue()
    },
    onCodeChange(editor) {
      this.addRemoteFnForm.fnCode = editor.getValue()
      this.editRemoteFnForm.fnCode = editor.getValue()
      //console.log("value",editor.getValue());
    },
    //得到云函数列表
    async getRemoteFnList(){
      //const result = await this.$http.get(`getRemoteFnList?email=${this.$store.state.account}`);
      //console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("remoteFnList",{
        params:this.queryInfo
      });
      this.state = false
      console.log('获取云函数result',result);
      if(result.data.meta.status == 200){
        if (result.data.data.total > 0) {
          this.total = result.data.data.total
          this.tableList = result.data.data.result.map(ele => {
            ele.createdAt = this.$moment(ele.createdAt).format('YYYY-MM-DD HH:mm:ss')
            ele.updatedAt = this.$moment(ele.updatedAt).format('YYYY-MM-DD HH:mm:ss')
            return ele
          })
        }else{
          this.total = 0
          this.tableList = []
        }
      }else{
        this.total = 0
        this.tableList = []
      }
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {email:this.$store.state.account});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
      this.allSoftName.unshift("全软件通用")
    },
    addRemoteFnBtn(){
      console.log("添加云函数");
      this.addDialogVisible = true
    },
    //添加云函数dialog关闭事件
    closeAddDiaLog(){
      this.editor1.setValue("")
      this.$refs.addRemoteFnFormRef.resetFields()
    },
    //编辑云函数dialog关闭事件
    closeEditDiaLog(){
      this.editor2.setValue("")
      // this.editor.setValue(this.editRemoteFnForm.fnCode)
      // this.editRemoteFnForm.fnCode = ""
      this.$refs.editRemoteFnRef.resetFields()
      // this.editRemoteFnForm.fnCode = ""
    },
    //创建云函数
    async createRemoteFn(){
      console.log("addRemoteFnForm.fnCode:", this.addRemoteFnForm.fnCode);
      this.$refs.addRemoteFnFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.addRemoteFnForm.email = this.$store.state.account
        const result = await this.$http.post("createRemoteFn", this.addRemoteFnForm);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.addDialogVisible = false
        this.$refs.addRemoteFnFormRef.resetFields()
        this.getRemoteFnList()
      })
    },
    refresh(){
      this.getCardTypeSoftName()
      this.getRemoteFnList()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getRemoteFnList()
    },
    reSet(){
      this.queryInfo.softName = ""
      // this.queryInfo.RemoteFnEmail = ""
      this.$refs.RemoteFnRef.resetFields()
      this.getRemoteFnList()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getRemoteFnList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getRemoteFnList()
    },
    
    //编辑按钮
    editRemoteFnBtn(index){
      this.addRemoteFnForm.fnCode = ""
      this.editRemoteFnForm.fnCode = ""
      this.editRemoteFnDialogVisible = true
      if(this.editor2){
        this.editor2.setValue(index.fnCode)
        console.log("设置代码",index.fnCode);
      }else{
        setTimeout(()=>{
          this.editor2.setValue(index.fnCode)
          console.log("延迟设置代码：",index.fnCode);
        },1000)
      }
      
      this.editRemoteFnForm = JSON.stringify(index)
      this.editRemoteFnForm = JSON.parse(this.editRemoteFnForm)
    },
    //编辑保存按钮
    editSaveBtn(){
      this.$refs.editRemoteFnRef.validate(async valid => {
        console.log(valid);
        console.log(this.editRemoteFnForm);
        if(!valid) return
        this.state = true
        this.editRemoteFnForm.email = this.$store.state.account
 
        const result = await this.$http.post("updateRemoteFn", this.editRemoteFnForm);
        this.state = false
        console.log('result=>',result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.editRemoteFnDialogVisible = false
        this.$refs.editRemoteFnRef.resetFields()
        this.getRemoteFnList()
      })
    },
    delRemoteFnBtn(index){
      this.editRemoteFnForm = index
      this.delRemoteFnDialog = true
    },
    async delRemoteFnDialogBtn(){
      this.state = true
      this.editRemoteFnForm.email = this.$store.state.account
      const result = await this.$http.post("delRemoteFn", this.editRemoteFnForm);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.delRemoteFnDialog = false
      this.getRemoteFnList()
    },
    changeVal(val){
      if (val === "全软件通用") {
        this.colorState = true
      }else{
        this.colorState = false
      }
      this.$forceUpdate()
      console.log("this.colorState:",this.colorState);
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}

</style>